import React, { useState } from "react";
import styled from "styled-components";
import LabsButton from "./LabsButton.jsx";
import PrivacyPolicyLink from "./PrivacyPolicyLink.jsx";
import ModalInquiry from "./Modal/ModalInquiry.jsx";
import ModalTermsOfService from "../Components/Modal/ModalTermsOfService.jsx";
import ModalFriendInvite from "./Modal/ModalFriendInvite.jsx";
import LogList from "../Components/LogList.jsx";
import plus from "../img/plus.png";
import inquiry from "../img/inquiry.png";
import terms from "../img/terms.png";
import invite from "../img/invite_gift.png";
import lawGranted from "../img/5_law_granted.png";
import { useChatNavigation } from "./ChatNavigationProvider.jsx";

const LogBar = () => {
  /* 이용약관 모달창 */
  const [isTermsModalOpen, setTermsModalIsOpen] = useState(false);
  const handleOpenTermsModal = () => {
    setTermsModalIsOpen(true);
  };
  const handleCloseTermsModal = () => {
    setTermsModalIsOpen(false);
  };

  /* 문의하기 모달창 */
  const [isInquiryModalOpen, setInquiryModalIsOpen] = useState(false);
  const handleOpenInquiryModal = () => {
    setInquiryModalIsOpen(true);
  };
  const handleCloseInquiryModal = () => {
    setInquiryModalIsOpen(false);
  };

  /* 친구초대 모달창 */
  const [isFriendInviteModalOpen, setFriendInviteModalIsOpen] = useState(false);
  const handleOpenFriendInviteModal = () => {
    setFriendInviteModalIsOpen(true);
  };
  const handleCloseFriendInviteModal = () => {
    setFriendInviteModalIsOpen(false);
  };

  const { requestNewSituation } = useChatNavigation();

  return (
    <Wrapper>
      <NewChat>
        <CustomButton
          image_src={plus}
          alt_text="새로운 상황"
          button_text="새로운 상황"
          width="100%"
          height="50px"
          imgWidth={32}
          imgHeight={32}
          gap={8}
          onClick={requestNewSituation}>
          <ButtonImg
            src={plus}
            alt="새로운 상황"
            imgWidth={32}
            imgHeight={32}
          />
          <ButtonText>새로운 상황</ButtonText>
        </CustomButton>
      </NewChat>
      <LogList />
      <InquiryTermsBox>
        {/* 친구초대 메뉴 */}
        <ModalFriendInvite
          isOpen={isFriendInviteModalOpen}
          onClose={handleCloseFriendInviteModal}
        />
        <FriendInviteContainer>
          <FriendInviteButton onClick={handleOpenFriendInviteModal}>
            <ButtonImg
              src={invite}
              alt="친구초대"
              imgWidth={32}
              imgHeight={32}
            />
            <ButtonText>친구초대</ButtonText>
          </FriendInviteButton>
          <BadgeOverlay>
            <BadgeImage src={lawGranted} alt="5로우 즉시 지급" />
          </BadgeOverlay>
        </FriendInviteContainer>
        <LabsButton sidebar />
        <ModalInquiry
          isOpen={isInquiryModalOpen}
          onCloseInquiry={handleCloseInquiryModal}
        />
        <CustomButton
          image_src={inquiry}
          alt_text="문의하기"
          button_text="문의하기"
          fontSize="16px"
          fontWeight="600"
          width="100%"
          height="44px"
          lineHeight="26px"
          onClick={() => handleOpenInquiryModal(true)}
          imgWidth={32}
          imgHeight={32}
          gap={8}>
          <ButtonImg
            src={inquiry}
            alt="문의하기"
            imgWidth={32}
            imgHeight={32}
          />
          <ButtonText>문의하기</ButtonText>
        </CustomButton>
        <ModalTermsOfService
          isOpen={isTermsModalOpen}
          onClose={handleCloseTermsModal}
        />
        <CustomButton
          image_src={terms}
          alt_text="이용약관"
          button_text="이용약관"
          fontSize="16px"
          fontWeight="600"
          width="100%"
          height="44px"
          lineHeight="26px"
          onClick={() => handleOpenTermsModal(true)}
          imgWidth={32}
          imgHeight={32}
          gap={8}>
          <ButtonImg src={terms} alt="이용약관" imgWidth={32} imgHeight={32} />
          <ButtonText>이용약관</ButtonText>
        </CustomButton>
        <PrivacyPolicyLink />


      </InquiryTermsBox>
    </Wrapper>
  );
};

const logBarMinWidth = "312px"; // 고정

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: ${logBarMinWidth};
  height: 100%;
  position: fixed;
  background-color: #f9f9f9;
  /* 자식요소들 동일하게 좌우 패딩 설정 */
`;

const NewChat = styled.div`
  height: auto;
  width: auto;
  padding: 16px 10px 23px; /* height가 padding 합해서 119px로 고정 */
  border: none; /* 테두리 스타일 제거 */
`;

const InquiryTermsBox = styled.div`
  padding: 24px 32px 0px 12px; /* padding-left에는 이미 20px이 되어있어서 12px로 설정함 */
  // margin-bottom: 64px;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
`;

const CustomButton = styled.button`
  background-color: transparent;
  width: ${(props) => (props.width === "auto" ? "auto" : `${props.width}`)};
  height: ${(props) => (props.height === "auto" ? "auto" : `${props.height}`)};
  border: none;
  border-radius: 5px;
  font-size: 16px;
  font-weight: 600;
  transition: background-color 0.3s ease;
  display: flex;
  align-items: center;
  gap: ${(props) => (props.gap !== undefined ? `${props.gap}px` : "0px")};
  cursor: pointer;
  padding: 0 20px; // 기본 설정된 padding값 삭제

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
`;

const ButtonImg = styled.img`
  width: ${(props) =>
    props.imgWidth === "auto" ? "auto" : `${props.imgWidth}px`};
  height: ${(props) =>
    props.imgHeight === "auto" ? "auto" : `${props.imgHeight}px`};
  flex-shrink: 0;
`;

const ButtonText = styled.span`
  font-family: Pretendard;
  font-style: normal;
  color: ${(props) => props.fontColor || "rgba(0, 0, 0, 0.6)"};
  font-size: ${(props) => props.fontSize || "16px"};
  font-weight: ${(props) => props.fontWeight || "600"};
  line-height: ${(props) => props.lineHeight || "26px"};
`;

const FriendInviteContainer = styled.div`
  position: relative;
  margin-bottom: 8px;
`;

const FriendInviteButton = styled.button`
  background-color: transparent;
  width: 100%;
  height: 44px;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  font-weight: 600;
  transition: background-color 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 0 20px;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
`;

const BadgeOverlay = styled.div`
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-46%);
  pointer-events: none; /* 클릭 이벤트가 버튼으로 전달되도록 */
`;

const BadgeImage = styled.img`
  width: 132px;
  height: 36px;
  object-fit: contain;
`;


export default LogBar;
